import React from 'react';
import { I18n } from 'react-redux-i18n';

const GenerateReportButton = (props) => {
  const { text, ariaLabel, handleConfirmation } = props;

  return (
    <div className="btn-group" role="group" aria-label={ariaLabel}>
      <button
        className="btn btn-primary"
        type="button"
        onClick={() => handleConfirmation()}
      >
        {I18n.t(text)}
      </button>
    </div>
  );
};

export default GenerateReportButton;
